import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { Logger } from '@dx/common';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private logger: Logger;

  constructor(private injector: Injector) { }

  handleError(error: Error) {
    this.logger = this.injector.get<Logger>(Logger as any);
    // handle loading chunk failed
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    if (chunkFailedMessage.test(error.message)) {
      this.logger.warn(error);
      window.location.reload();
    }
    // only log 500 errors and non http response errors
    if (!(error instanceof HttpErrorResponse) || (error as HttpErrorResponse).status === 500) {
      this.logger.error(error);
    }
  }
}
